import React, { useContext } from 'react'
import { connect } from 'react-redux'
import ClientHeaderNav from 'components/layout-components/ClientHeaderNav'
import { Layout } from 'antd'
import ClientViews from 'views/client-views/ClientViews'
import { State } from 'views/AppContext'

import './clientLayout.scss'
import ClientAppContext from 'views/client-views/ClientAppContext'

const { Content } = Layout

export const ClientLayout = () => {
  const { clientStatus } = useContext(State)

  const showRoutes = () => {
    const { is_register, has_payment, has_file } = clientStatus

    return is_register && has_payment && has_file
  }

  return (
    <ClientAppContext>
      <Layout>
        <ClientHeaderNav showRoutes={showRoutes()} />
        <Content className="client-layout__content p-md-5 h-100">
          <ClientViews />
        </Content>
        {/* <Footer /> */}
      </Layout>
    </ClientAppContext>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme
  return { navCollapsed, navType, locale }
}

export default connect(mapStateToProps)(React.memo(ClientLayout))
